import * as rxjs from 'rxjs';
import * as gqlTypes from 'generated/graphql';
import { FetchResult } from '@apollo/client';


import { client } from 'modules/common/layer01';
import _ from 'lodash';

type IUploadAlertCompleteInput = {
  message: 'uploadComplete';
  fileName: string;
  progress: number;
  uploadId: string;
  type: gqlTypes.ApiFile['__typename'];
};

type IUploadType = gqlTypes.ApiFile['__typename'];

type IUploadProgressInput = {
  message: 'inProgress';
  fileName: string;
  progress: number;
  uploadId: null;
  type: IUploadType;
};

type IQueueEmptyInput = {
  message: number;
};


export function getQueueUploadObservable() {
  return __queueAlert.asObservable();
}
export function getProgressObservable() {
  return __uploadAlert.asObservable();
}

type IUploadAlertInput = IUploadProgressInput | IUploadAlertCompleteInput;

const __queueAlert = new rxjs.Subject<IQueueEmptyInput>();
const __uploadAlert = new rxjs.Subject<IUploadAlertInput>();

const chunkSize = 5242880;


const __uploadQueue: File[] = [];

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export async function addToQueue(files: FileList, createType: IUploadType) {
  __uploadQueue.push(...files);
  while (__uploadQueue.length > 0) {
    __queueAlert.next({
      message: __uploadQueue.length
    });
    const file = __uploadQueue.shift();

    if (!file) {
      debugger;
      return;
    }
    uploadFile(file);
  }
  __queueAlert.next({
    message: 0
  });
}

async function __finalizeReservation(input: gqlTypes.FinalizeMultiPartFileReservationInput) {

  const reservationResp: FetchResult<gqlTypes.FinalizeFileMultiPartReservationMutation > = await client.mutate({
    mutation: gqlTypes.FinalizeFileMultiPartReservationDocument,
    variables: {
      input
    }
  });

  return {
    id: reservationResp.data?.finalizeMultiPartFileReservation?.apiFile?.id ?? '',
    url: reservationResp.data?.finalizeMultiPartFileReservation?.apiFile?.url ?? ''
  };
}
type ICreateReservationResponse = {
  signedUploadUrls: string[] | null;
  uploadId: string | null;
  id: string | null;
};

async function __createReservations(file: File): Promise<ICreateReservationResponse> {
  const totalParts = Math.ceil(file.size / chunkSize);

  const reservationInput: gqlTypes.CreateMultiPartFileReservationInput = {
    fileName: file.name,
    mimeType: file.type,
    sizeBytes: file.size,
    totalParts
  };

  const reservationResp: FetchResult<gqlTypes.CreateFileMultiPartReservationMutation > = await client.mutate({
    mutation: gqlTypes.CreateFileMultiPartReservationDocument,
    variables: {
      input: reservationInput
    }
  });


  const resp = {
    signedUploadUrls: reservationResp.data?.createMultipartFileReservation?.signedUploadUrls ?? null,
    uploadId: reservationResp.data?.createMultipartFileReservation?.uploadId ?? null,
    id: reservationResp.data?.createMultipartFileReservation?.id ?? null
  };


  if (_.isEmpty(resp.signedUploadUrls)) {
    throw newDebugError(`${console.trace('Could not find upload url')}`);
  }
  if (_.isNull(resp.uploadId)) {
    throw newDebugError(`${console.trace('Could not find uploadId')}`);
  }
  if (_.isNull(resp.id)) {
    throw newDebugError(`${console.trace('Could not find reservation')}`);
  }

  return resp;
}

async function uploadFile(file: File) {
  const { signedUploadUrls, uploadId, id } = await __createReservations(file);
  if (!signedUploadUrls) {
    throw newDebugError(`${console.trace('Could not find Upload URLS')}`);
  }
  const parts = await readAndUploadCurrentChunk(file, signedUploadUrls);
  const apiFile = await __finalizeReservation({
    id: id ?? '',
    partList: parts,
    uploadId: uploadId ?? ''
  });
  __uploadAlert.next({
    progress: 100,
    uploadId: apiFile.id,
    fileName: file.name,
    message: 'uploadComplete',
    type: 'ApiFile'
  });

}

async function readAndUploadCurrentChunk(file: File, signedUploadUrls: string[]) {
  const totalChunks = Math.ceil(file.size / chunkSize);
  const parts: gqlTypes.FinalizeMultiPartFileReservationInput['partList'] = [];


  const uploadChunks = [];

  for (let currentChunk = 0; currentChunk < totalChunks; currentChunk++) {
    const from = (currentChunk) * chunkSize;
    const to = from + chunkSize;
    const blob = file.slice(from, to);
    const presigned = signedUploadUrls[currentChunk] ?? '';

    uploadChunks.push(__readChunk(file, currentChunk, blob, totalChunks, presigned));
    // const part = await __readChunk(file, currentChunk, blob, totalChunks, presigned);
    // parts.push({
    //   eTag: part.ETag, partNumber: part.PartNo
    // });
  }
  const allUploadedParts = await Promise.all(uploadChunks);

  allUploadedParts.forEach((part) => {
    parts.push({
      eTag: part.ETag,
      partNumber: part.PartNo
    });
  });

  return parts;
}

function __readChunk(file: File, currentChunk: number, blob: Blob, totalChunks: number, presigned: string) {
  return new Promise<{ ETag: string; PartNo: number }>((resolve) => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      const resp = await uploadChunk(blob, e, file, currentChunk, totalChunks, presigned);
      if (!resp) {
        throw newDebugError(`${console.trace('Could not find ETAG')}`);
      }

      resolve(resp);

    };
    reader.readAsDataURL(blob);
  });
}

async function uploadChunk(blob: Blob, readerEvent: ProgressEvent<FileReader>, file: File, currentChunk: number, totalChunks: number, presigned: string) {

  if (!readerEvent.target) {
    return;
  }
  const data = readerEvent.target.result?.toString();
  if (!data) {
    return;
  }

  try {
    const resp = await fetch(presigned, {
      method: 'PUT',
      body: blob
    });
    return {
      ETag: resp.headers.get('ETag') ?? '',
      PartNo: currentChunk + 1
    };

  } catch (error) {
    console.log(error);
    return {
      ETag: '',
      PartNo: currentChunk + 1
    };
  }



}

function newDebugError(message: string) {

  throw new Error(message);

}

